<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                class="content-title d-flex align-center mr-2"
                :class="mode ? 'content__titleday' : 'content__titlenight'"
              >
                {{ $t("message.quiz_plan") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                  ></crm-input>
                </div>
              </div>
              <!-- <div class="block-sarche ml-2">
                              <select-branch  
                                :size="'small'"
                                :class="mode ? 'input__day' : 'input__night'"
                                :id="filterForm.branch_id"
                                v-model="filterForm.branch_id" >
                              </select-branch>
                            </div> -->
            </div>
          </el-col>

          <el-col :span="12" class="flex-style text-right">
            <crm-create-and-column-settings
              :permission="$options.name"
              :class="mode ? 'button__settingsday' : 'button__settingsnight'"
              @c-create="drawerCreate = true"
              :columns="columns"
              @c-change="updateColumn"
              :v_can_create="'quiz_plans.create'"
            >
            </crm-create-and-column-settings>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->

      <div class="card-table-header table-crm-smart">
        <table
          :class="mode ? 'table__myday' : 'table__mynight'"
          class="table-my-code table-bordered"
          v-loading="loadingData"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.name.show">
                {{ columns.name.title }}
              </th>

              <th v-if="columns.company.show">
                {{ columns.company.title }}
              </th>
              <th v-if="columns.branch.show">
                {{ columns.branch.title }}
              </th>
              <th v-if="columns.department.show">
                {{ columns.department.title }}
              </th>
              <th v-if="columns.daly_question_count.show">
                {{ columns.daly_question_count.title }}
              </th>
              <th v-if="columns.from_date.show">
                {{ columns.from_date.title }}
              </th>
              <th v-if="columns.to_date.show">
                {{ columns.to_date.title }}
              </th>
              <th v-if="columns.send_question_time.show">
                {{ columns.send_question_time.title }}
              </th>
              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>
              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.name.show">
                <crm-input
                  :placeholder="columns.name.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.name"
                ></crm-input>
              </th>

              <th v-if="columns.company.show">
                <select-company
                  :id="filterForm.company_id"
                  v-model="filterForm.company_id"
                  :size="'mini'"
                ></select-company>
              </th>
              <th v-if="columns.branch.show">
                <select-branch
                  :company_id="filterForm.company_id"
                  v-model="filterForm.branch_id"
                  :id="filterForm.branch_id"
                  :size="'mini'"
                ></select-branch>
              </th>
              <th v-if="columns.department.show">
                <select-department
                  :branch_id="filterForm.branch_id"
                  v-model="filterForm.department_id"
                  :id="filterForm.department_id"
                  :size="'mini'"
                ></select-department>
              </th>
              <th v-if="columns.daly_question_count.show">
                <crm-input
                  :class="mode ? 'input__day' : 'input__night'"
                  :inputValue="filterForm.daly_question_count"
                  :placeholder="$t('message.daly_question_count')"
                  v-model="filterForm.daly_question_count"
                  size="mini"
                  :type="'number'"
                ></crm-input>
              </th>
              <th v-if="columns.from_date.show">
                <crm-date-picker
                  :placeholder="columns.from_date.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.from_date"
                ></crm-date-picker>
              </th>
              <th v-if="columns.to_date.show">
                <crm-date-picker
                  :placeholder="columns.to_date.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.to_date"
                ></crm-date-picker>
              </th>
              <th v-if="columns.send_question_time.show">
                <el-time-select
                  required
                  :size="'mini'"
                  :placeholder="$t('message.send_question_time')"
                  v-model="filterForm.send_question_time"
                  :picker-options="{
                    start: '07:00',
                    step: '01:00',
                    end: '22:00'
                  }"
                  class="w-100"
                  :class="mode ? 'input__day' : 'input__night'"
                ></el-time-select>
              </th>
              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                ></crm-date-picker>
              </th>
              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                ></crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="quiz_plan in list"
              :key="quiz_plan.id"
              class="cursor-pointer"
            >
              <td v-if="columns.id.show">{{ quiz_plan.id }}</td>
              <td v-if="columns.name.show">
                {{ quiz_plan.name }}
              </td>
              <td v-if="columns.company.show">
                {{ quiz_plan.company ? quiz_plan.company.name : "" }}
              </td>
              <td v-if="columns.branch.show">
                {{ quiz_plan.branch ? quiz_plan.branch.name : "" }}
              </td>
              <td v-if="columns.department.show">
                {{ quiz_plan.department ? quiz_plan.department.name : "" }}
              </td>
              <td v-if="columns.daly_question_count.show">
                {{ quiz_plan.daly_question_count }}
              </td>
              <td v-if="columns.from_date.show">
                {{ quiz_plan.from_date }}
              </td>
              <td v-if="columns.to_date.show">
                {{ quiz_plan.to_date }}
              </td>
              <td v-if="columns.send_question_time.show">
                {{ quiz_plan.send_question_time }}
              </td>
              <td v-if="columns.created_at.show">
                {{ quiz_plan.created_at }}
              </td>

              <td v-if="columns.updated_at.show">
                {{ quiz_plan.updated_at }}
              </td>

              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="quiz_plan"
                  :actions="actions"
                  @edit="edit"
                  :permissionShow="'quiz_plans.update'"
                  :permissionDestroy="'quiz_plans.destroy'"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>

      <div class="app-modal app-modal__full">
        <el-drawer
          :with-header="false"
          :visible.sync="drawerCreate"
          size="70%"
          ref="drawerCreate"
          @opened="drawerOpened('drawerCreateChild')"
          @closed="drawerClosed('drawerCreateChild')"
        >
          <crm-create
            ref="drawerCreateChild"
            drawer="drawerCreate"
          ></crm-create>
        </el-drawer>

        <el-drawer
          :with-header="false"
          :visible.sync="drawerUpdate"
          size="70%"
          ref="drawerUpdate"
          @opened="drawerOpened('drawerUpdateChild')"
          @closed="drawerClosed('drawerUpdateChild')"
        >
          <crm-update
            :selectedItem="selectedItem"
            ref="drawerUpdateChild"
            drawer="drawerUpdate"
          ></crm-update>
        </el-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import list from "@/utils/mixins/list";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "questionCategoryListController",
  mixins: [list],
  components: {
    CrmCreate,
    CrmUpdate
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      list: "quizPlan/list",
      columns: "quizPlan/columns",
      pagination: "quizPlan/pagination",
      statues: "quizPlan/statues",
      filter: "quizPlan/filter",
      sort: "quizPlan/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["edit", "delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "quizPlan/index",
      setPagination: "quizPlan/setPagination",
      updateSort: "quizPlan/updateSort",
      updateFilter: "quizPlan/updateFilter",
      updateColumn: "quizPlan/updateColumn",
      updatePagination: "quizPlan/updatePagination",
      show: "quizPlan/show",
      empty: "quizPlan/empty",
      delete: "quizPlan/destroy",
      refreshData: "quizPlan/refreshData"
    })
  }
};
</script>
